import type { WarchestDataConfig } from "../types/game-data-config";
import { BOARDS } from "./boards";
import { BASE_UNITS } from "./units";

export const DEFAULT_CONFIG: WarchestDataConfig = {
  units: BASE_UNITS,
  boards: BOARDS,
};

export const DEFAULT_BOARD_ID = "base-2p";
export const CONTROL_MARKERS_TO_WIN = 6;
export const HAND_DRAW_COUNT = 3;
export const COINS_PER_UNIT_IN_BAG = 2;
